import axios from "axios"
import SessionManager from "@/utils/session-manager"

const AxiosAuthGet = async (uri) => {
    try {
        return await axios({
            method: 'GET',
            url: uri,
            headers: {
                Authorization: `Bearer ${SessionManager.getAuthToken()}`
            }        
        })
    } catch(error) {
        return error
    }
}

const AxiosAuthPost = async (uri, data) => {
    try {
        return await axios({
            method: 'POST',
            url: uri,
            data: data,
            headers: {
                Authorization: `Bearer ${SessionManager.getAuthToken()}`
            }        
        })
    } catch(error) {
        return error
    }
}

const AxiosAuthPut = async(uri, data) => {
    return await axios({
        method: 'PUT',
        url: uri,
        data: data,
        headers: {
            Authorization: `Bearer ${SessionManager.getAuthToken()}`
        }        
    })
}

const AxiosAuthDelete = async (uri, data) => {
    return await axios({
        method: 'DELETE',
        url: uri,
        data: data,
        headers: {
            Authorization: `Bearer ${SessionManager.getAuthToken()}`
        }        
    })
}

export default {AxiosAuthGet, AxiosAuthPost, AxiosAuthPut, AxiosAuthDelete}


// WEBPACK FOOTER //
// ./src/services/request/index.js